<template>
  <div id="test-welcome-content" class="wrapper" :class="{extended: isExtendedView, small: isSmallView}">
    <div class="row text-center text-md-left">
      <div class="col-md-4 mb-5"><img src="../assets/images/no_roooms.svg" alt="welcome" class="img-fluid"></div>
      <div class="col-md-8">
        <h2>{{ $t('welcome.title') }}</h2>
        <p>{{ $t('welcome.subTitle') }}</p>
        <p>{{ $t('welcome.content') }}</p>
        <p>{{ $t('welcome.footer') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  computed: mapGetters(['isSmallView', 'isExtendedView']),
})
export default class Welcome extends Vue {}
</script>

<style lang="scss" scoped>
  @import "../assets/variables";

  .wrapper {
    padding-left: 220px;
    padding-right: 40px;

    &.small {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .row {
    margin-top: 100px;
  }

  h2 {
    color: $black-lighter;
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 26px;
  }

  p {
    color: $black-lighter;
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 25px;
  }
</style>
